/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dx-currency-cell[_ngcontent-%COMP%]{text-align:right}.dx-currency-cell.highlight[_ngcontent-%COMP%]{color:#db2828}\n/*# sourceMappingURL=dx-currency-cell-render.component.css.map*/"];
export { styles as styles };
